<!-- eslint-disable max-len -->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill-rule="evenodd"
      d="M3.5 0h11.67a3.5 3.5 0 0 1 3.5 3.5v7.78a1.17 1.17 0 1 1-2.34 0V3.5c0-.64-.52-1.17-1.16-1.17H3.5c-.64 0-1.17.53-1.17 1.17V14c0 .64.53 1.17 1.17 1.17h7.68a1.17 1.17 0 1 1 0 2.33H3.5A3.5 3.5 0 0 1 0 14V3.5A3.5 3.5 0 0 1 3.5 0ZM24.5 25.67c.64 0 1.17-.53 1.17-1.17v-1.9a1.17 1.17 0 1 1 2.33 0v1.9a3.5 3.5 0 0 1-3.5 3.5h-1.9a1.17 1.17 0 0 1 0-2.33h1.9Zm-4.52 1.16c0 .65-.52 1.17-1.17 1.17h-3.79a1.17 1.17 0 1 1 0-2.33h3.8c.64 0 1.16.52 1.16 1.16Zm-7.58 0c0 .65-.53 1.17-1.17 1.17h-1.9a1.17 1.17 0 1 1 0-2.33h1.9c.64 0 1.17.52 1.17 1.16Zm14.43-6.85c-.64 0-1.16-.52-1.16-1.17v-3.79a1.17 1.17 0 1 1 2.33 0v3.8c0 .64-.52 1.16-1.17 1.16Zm0-7.58c-.64 0-1.16-.53-1.16-1.17v-1.9a1.17 1.17 0 1 1 2.33 0v1.9c0 .64-.52 1.17-1.17 1.17Z"
      clip-rule="evenodd"
    />
    <path
      fill-rule="evenodd"
      d="M25.67 9.33c0-.64-.53-1.16-1.17-1.16h-1.17a1.17 1.17 0 0 1 0-2.34h1.17a3.5 3.5 0 0 1 3.5 3.5h-2.33ZM9.33 28a3.5 3.5 0 0 1-3.5-3.5v-1.17a1.17 1.17 0 0 1 2.34 0v1.17c0 .64.52 1.17 1.16 1.17V28ZM8.55 7.3c.48-.43 1.21-.4 1.65.08l9.63 10.6v-4.56a1.17 1.17 0 1 1 2.34 0V21c0 .64-.53 1.17-1.17 1.17h-7.65a1.17 1.17 0 0 1 0-2.34h5.01L8.47 8.95c-.43-.48-.4-1.21.08-1.65Z"
      clip-rule="evenodd"
    />
  </svg>
</template>
